import { SyntacticSugarService } from "../sys/syntactic-sugar.service";
import { Injectable } from '@angular/core';
    
import { CacheService } from './../sys/cache.service';
    
@Injectable()
export class PageTitleService {
    
    private pageTitle : string = "";
    private infoBannerTitle: string = "";
    private infoBannerHidden: boolean = true;
     
    constructor(private cacheService: CacheService,
                private syntacticSugarService: SyntacticSugarService) {
         
    };
    
    /**
     * Gets the title to display in the browser tab.  Strip out the HTML which may be
     * present in the pageTitle since it will not render.
     */
    getWindowPageTitle() : string {
        let windowTitle: string = this.cacheService.getLabelFromResource('COMMON:COMMON100413');
        return this.syntacticSugarService.stripHtml(this.pageTitle + windowTitle);
    }
    
    getPageTitle() {
        return this.pageTitle;
    }
    
    setPageTitle(newPageTitle) {
        this.pageTitle = newPageTitle;
    }

    getInfoBannerTitle() {
        return this.infoBannerTitle; 
    }
    
    setInfoBannerTitle(newInfoBannerTitle) {
        this.infoBannerTitle = newInfoBannerTitle;
    }

    getInfoBannerHidden() {
        return this.infoBannerHidden; 
    }
    
    setInfoBannerHidden(newInfoBannerHidden) {
        this.infoBannerHidden = newInfoBannerHidden;
    }

}